import { render, staticRenderFns } from "./SupplierCategories.vue?vue&type=template&id=30d3faab&"
import script from "./SupplierCategories.vue?vue&type=script&lang=js&"
export * from "./SupplierCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports